module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vue-router-page-transition-162.vue");


//////////////////
// WEBPACK FOOTER
// ./en/development/vue-router-page-transition.md
// module id = 579
// module chunks = 211